import { FilterMatchMode } from "primereact/api";

export class RefBancaria {

    model = {
        id: {
            value: null,
            export: true,
            header: 'Código',
            table: false,
            filterPlaceholder: 'Buscar por código',
            filterField: 'id',
            sort: true,
            matchMode: FilterMatchMode.EQUALS,
            showFilterMatchModes: false,
            headerStyle: { width: '10%', minWidth: '10rem' }
        },
        banco: {
            value: '',
            export: true,
            header: 'BANCO',
            table: true,
            sort: false,
            headerStyle: { width: '30%', minWidth: '20rem' },
            filterPlaceholder: 'Buscar',
            filterField: 'banco',
            matchMode: FilterMatchMode.CONTAINS,
            required: 'Campo requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4,
        },
        numero_cuenta: {
            value: '',
            export: true,
            header: 'No.CUENTA',
            table: true,
            sort: false,
            headerStyle: { width: '30%', minWidth: '20rem' },
            filterPlaceholder: 'Buscar',
            filterField: 'numero_cuenta',
            matchMode: FilterMatchMode.CONTAINS,
            required: 'Campo requerido',
            maxLength: 'Máximo 40 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 40,
            min: 4,
        },
        tipo_cuenta: {
            value: '',
            export: true,
            header: 'TIPO CUENTA',
            table: true,
            sort: false,
            filterPlaceholder: 'Buscar',
            filterField: 'tipo_cuenta',
            matchMode: FilterMatchMode.CONTAINS,
            required: 'Campo requerido',
            maxLength: 'Máximo 150 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 150,
            min: 4,
        },
        saldo_promedio: {
            value: 0,
            export: false,
            header: 'SALDO PROMEDIO:',
            required: 'Valor requerido.'
        },
    }
}